import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { documentsActions } from "../../../_store/documents.slice";
import { fDate, fDate1, fDateDoc } from "./../../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import NoDataimg from "../../../assets/No_Data.png";
import { history } from "../../../_helpers";
import { ThreeDots } from "react-loader-spinner";
import { DateInput } from "../../../components/common/ui/Inputs";
import Button from "../../../components/common/ui/Button";
import { useParams } from "react-router-dom";
import CustomLoader from "../../../components/common/ui/Loader";

const CommitteeDocumentPage = () => {
  const { categories_List, documents_List, loading, catloading } = useSelector(
    (state) => state.documents
  );

  const { committeeID } = useParams();
  const [toggleAccordian, setToggleAccordian] = useState({
    checked: false,
    position: null,
  });

  const [lastLoadedCategoryId, setLastLoadedCategoryId] = useState(null);

  const [categoryDocs, setCategoryDocs] = useState({});

  const [apiParams, setApiParams] = useState(
    `&page=${1}&limit=${5}&status=${true}`
  );

  const [dateRange, setDateRange] = useState({
    StartDate: "",
    EndDate: "",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "5",
      ...Object.fromEntries(
        Object.entries(dateRange).filter(([_, v]) => v !== "")
      ),
    }).toString();

    setApiParams(`&${query}`);
  }, [dateRange]);

  const navigate = useNavigate();

  // useEffect(() => {
  //   //fetch data for List the committee documents
  //   if (!committeeID?._id) {
  //     navigate("/Committee");
  //   }

  //   dispatch(documentsActions.getCategoriesList(committeeID._id));
  // }, [committeeID]);

  useEffect(() => {
    dispatch(documentsActions.getCategoriesList(committeeID));
  }, [committeeID]);

  useEffect(() => {
    if (!lastLoadedCategoryId || !documents_List?.data) return;

    const newDocs = documents_List?.data?.documents || [];

    setCategoryDocs((prev) => {
      const prevDocs = prev[lastLoadedCategoryId]?.documents || [];
      return {
        ...prev,
        [lastLoadedCategoryId]: {
          documents: [...prevDocs, ...newDocs],
          currentPage: documents_List?.data?.currentPage,
          totalPages: documents_List?.data?.totalPages,
        },
      };
    });
  }, [documents_List]);

  const dispatch = useDispatch();

  const handleAccordian = (e, position, id) => {
    debugger;
    //clear the excisting documents while i open other categories
    if (toggleAccordian.position !== position) {
      dispatch(documentsActions.clearDocumentList());
    }

    const isChecked = e?.target?.checked;

    setToggleAccordian({
      checked: isChecked,
      position,
    });

    // Load first page only if not already loaded
    if (isChecked && !categoryDocs[id]) {
      // if (isChecked) {
      loadDocuments(id, 1);
    }
  };

  const loadDocuments = async (categoryId, page = 1, reset = false) => {
    const limit = 5;
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    try {
      setLastLoadedCategoryId(categoryId);

      const res = await dispatch(
        // documentsActions.getDocumentsByCategory({
        //   id: categoryId,
        //   limit,
        //   page,
        //   StartDate: dateRange?.StartDate,
        //   EndDate: dateRange?.EndDate,
        // })
        documentsActions.getDocumentsByCategory({
          id: categoryId,
          params: updatedParams,
        })
      ).unwrap();

      const newDocs = res?.data?.documents || [];

      setCategoryDocs((prev) => {
        const prevDocs = reset ? [] : prev[categoryId]?.documents || [];

        // Merge and deduplicate by _id
        const allDocs = [...prevDocs, ...newDocs];
        const dedupedDocsMap = new Map();

        allDocs.forEach((doc) => {
          dedupedDocsMap.set(doc._id, doc); // assuming _id is unique
        });

        const dedupedDocs = Array.from(dedupedDocsMap.values());

        return {
          ...prev,
          [categoryId]: {
            documents: dedupedDocs,
            currentPage: res?.data?.currentPage,
            totalPages: res?.data?.totalPages,
          },
        };
      });
    } catch (err) {
      console.error("Failed to load documents:", err);
    }
  };

  const handleScroll = (e, categoryId) => {
    const el = e.target;
    const isBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

    const categoryState = categoryDocs[categoryId];

    if (
      isBottom &&
      categoryState &&
      categoryState.currentPage < categoryState.totalPages
    ) {
      const nextPage = categoryState.currentPage + 1;

      // Only load next page if not already loaded
      if (categoryState.currentPage < nextPage) {
        loadDocuments(categoryId, nextPage);
      }
    }

    // Do nothing when scrolling up — because we already have previous data
  };

  //   const handleChange = (date, name) => {
  //   if (name === "StartDate") {
  //     setDateRange((prev) => ({
  //       ...prev,
  //       EndDate: "",
  //     }));
  //   }
  //   setDateRange((prev) => ({
  //     ...prev,
  //     [name]: fDateDoc(date),
  //   }));
  // };

  // Above Code Comment because of I was select one date means previous date was selected
  const handleChange = (date, name) => {
    if (name === "StartDate") {
      setDateRange((prev) => ({
        ...prev,
        EndDate: "",
      }));
    }
    setDateRange((prev) => ({
      ...prev,
      [name]: fDate1(date),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (toggleAccordian?.checked) {
      dispatch(documentsActions.clearDocumentList());
      setCategoryDocs({});
      dispatch(
        documentsActions.getDocumentsByCategory({
          id: lastLoadedCategoryId,
          params: apiParams,
        })
      );
    }
  };

  if (catloading) return <CustomLoader />;

  return (
    //sscroll
    <>
      {categories_List?.data?.length > 0 ? (
        <section className="documents-section">
          <div className="d-flex justify-content-center gap-3 mb-3 document-date-section">
            <form
              className="p-3 row d-flex justify-content-center align-items-end"
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="col-md-5">
                <DateInput
                  name="StartDate"
                  id="start"
                  handleChange={(e) => {
                    handleChange(e, "StartDate");
                  }}
                  placeholder="Select Date"
                  // showTimeSelect={true}
                  label={"Start Date"}
                  value={dateRange?.StartDate}
                  // isClearable={eventForm?.start}
                  // errorMessage={errorMessage}
                  // required
                  maxDate={new Date()}
                />
              </div>
              <div className="col-md-5">
                <DateInput
                  name="EndDate"
                  id="end"
                  value={dateRange?.EndDate}
                  handleChange={(e) => {
                    handleChange(e, "EndDate");
                  }}
                  placeholder="Select Date"
                  // showTimeSelect={true}
                  label={"End Date"}
                  // isClearable={eventForm?.end}
                  // errorMessage={errorMessage}
                  minDate={dateRange?.StartDate}
                  maxDate={new Date()}
                  // minTime={
                  //   !isSameDay(
                  //     eventForm?.start,
                  //     eventForm?.end === "" ? eventForm?.start : eventForm?.end
                  //   )
                  //     ? new Date(new Date().setHours(0, 0, 0, 0))
                  //     : eventForm?.start
                  // }
                  // maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                />
              </div>
              {dateRange?.StartDate && dateRange?.EndDate && (
                <div className="col-md-2 d-flex align-items-end mb-1">
                  <Button status="secondary" label="Search" type="submit" />
                </div>
              )}
            </form>
          </div>
          <div className="container">
            <div className="accordion" id="meetingAccordion">
              {categories_List?.data?.map((category, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        toggleAccordian?.checked &&
                        index + 1 === toggleAccordian?.position
                          ? ""
                          : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#${category?.title.replace(/\s+/g, "")}`}
                      onClick={() =>
                        handleAccordian(
                          {
                            target: {
                              checked:
                                toggleAccordian?.position === index + 1
                                  ? !toggleAccordian?.checked
                                  : true,
                            },
                          },
                          index + 1,
                          category?._id
                        )
                      }
                    >
                      {category?.title}
                    </button>
                  </h2>

                  <div
                    id={category?.title.replace(/\s+/g, "")}
                    className="accordion-collapse collapse"
                    data-bs-parent="#meetingAccordion"
                  >
                    <div
                      className="accordion-body"
                      style={{ maxHeight: "360px", overflowY: "auto" }}
                      onScroll={(e) => handleScroll(e, category?._id)}
                    >
                      {categoryDocs[category?._id]?.documents.length > 0
                        ? categoryDocs[category?._id]?.documents?.map(
                            (document, i) => (
                              <div className="meeting-item" key={i}>
                                <div className="d-flex align-items-start">
                                  <i className="bi bi-file-earmark-text meeting-icon"></i>
                                  <div>
                                    <p className="meeting-title mb-1">
                                      {document?.title}
                                    </p>
                                    <p className="meeting-date">
                                      {`${fDate(document?.createdAt)} by ${
                                        document?.createdBy?.firstName || ""
                                      } ${document?.createdBy?.lastName || ""}`}
                                    </p>
                                  </div>
                                </div>
                                <a
                                  href={`${process.env.REACT_APP_API_IMAGE_URL}${document?.file}`}
                                  target="blank"
                                  rel="noreferrer"
                                  className="btn btn-download"
                                  aria-label={`Download document: ${document?.title || "file"}`}
                                  onClick={() =>
                                    dispatch(
                                      documentsActions?.trackDownloads({
                                        id: document?._id,
                                      })
                                    )
                                  }
                                >
                                  <span className="download-btn-text">
                                    Download{" "}
                                  </span>
                                  <span className="download-btn-icon">
                                    <i className="fa fa-download"></i>
                                  </span>
                                </a>
                              </div>
                            )
                          )
                        : !loading && (
                            <h3 className="text-danger d-flex justify-content-center">
                              No Documents Found
                            </h3>
                          )}

                      {loading &&
                        toggleAccordian?.checked &&
                        toggleAccordian?.position === index + 1 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              padding: "20px",
                            }}
                          >
                            <ThreeDots
                              height="180"
                              width="160"
                              color="#4fa94d"
                              visible={true}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : (
        <div className="sign-in-section">
          <div className="container">
            <div className="login-container">
              <div className="error-page-box p-5 d-flex flex-column justify-content-center align-items-center">
                <img src={NoDataimg} alt="404" />
                <h2 className="error-page-label">No Documents Found</h2>
                <button
                  onClick={() => {
                    history?.navigate("/Home");
                  }}
                  type="submit"
                  className="sign-in-button"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommitteeDocumentPage;

{
  /* <section className="documents-section">
        <div className="container">
          <div className="row">
            <div className="accordion" id="meetingAccordion">
              {categories_List?.data?.length > 0 ? (
                categories_List?.data?.map((category, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${
                          toggleAccordian?.checked &&
                          index + 1 === toggleAccordian?.position
                            ? ""
                            : "collapsed"
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${category?.title.replace(
                          /\s+/g,
                          ""
                        )}`}
                        onClick={() =>
                          handleAccordian(
                            {
                              target: {
                                checked:
                                  toggleAccordian?.position === index + 1
                                    ? !toggleAccordian?.checked
                                    : true,
                              },
                            },
                            index + 1,
                            category?._id
                          )
                        }
                      >
                        {category?.title}
                      </button>
                    </h2>

                    <div
                      id={category?.title.replace(/\s+/g, "")}
                      className="accordion-collapse collapse"
                      data-bs-parent="#meetingAccordion"
                    >
                      <div
                        className="accordion-body"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                        onScroll={(e) => handleScroll(e, category?._id)}
                      >
                        {categoryDocs[category?._id]?.documents.length > 0 ? (
                          categoryDocs[category?._id]?.documents?.map(
                            (document, i) => (
                              <div className="meeting-item" key={i}>
                                <div className="d-flex align-items-start">
                                  <i className="bi bi-file-earmark-text meeting-icon"></i>
                                  <div>
                                    <p className="meeting-title mb-1">
                                      {document?.title}
                                    </p>
                                    <p className="meeting-date">
                                      {`${fDate(document?.createdAt)} by ${
                                        document?.createdBy?.firstName || ""
                                      } ${document?.createdBy?.lastName || ""}`}
                                    </p>
                                  </div>
                                </div>
                                <a
                                  href={`${process.env.REACT_APP_API_IMAGE_URL}${document?.file}`}
                                  target="self"
                                  rel="noreferrer"
                                  className="btn btn-download"
                                  aria-label={`Download document: ${document?.title || "file"}`}
                                >
                                  Download
                                </a>
                              </div>
                            )
                          )
                        ) : (
                          <h3 className="text-danger d-flex justify-content-center">
                            No Categories Found
                          </h3>
                        )}

                        {loading &&
                          toggleAccordian?.checked &&
                          toggleAccordian?.position === index + 1 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "20px",
                              }}
                            >
                              <ThreeDots
                                height="180"
                                width="160"
                                color="#4fa94d"
                                visible={true}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <section className="sign-in-section">
                  <div className="container error-page-box">
                    <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                      <img src={NoDataimg} alt="404" />
                      <h2 className="error-page-label">No Documents Found</h2>
                      <button
                        onClick={() => {
                          history?.navigate("/Home");
                        }}
                        type="submit"
                        className="sign-in-button"
                      >
                        Back to Home
                      </button>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      </section> */
}

{
  /* {categories_List?.data?.length > 0 ? (
        <section className="members-section">
          <div className="container">
            <div className="row">
              <div className="accordion" id="meetingAccordion">
                {categories_List?.data?.map((category, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${
                          toggleAccordian?.checked &&
                          index + 1 === toggleAccordian?.position
                            ? ""
                            : "collapsed"
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${category?.title.replace(
                          /\s+/g,
                          ""
                        )}`}
                        onClick={() =>
                          handleAccordian(
                            {
                              target: {
                                checked:
                                  toggleAccordian?.position === index + 1
                                    ? !toggleAccordian?.checked
                                    : true,
                              },
                            },
                            index + 1,
                            category?._id
                          )
                        }
                      >
                        {category?.title}
                      </button>
                    </h2>

                    <div
                      id={category?.title.replace(/\s+/g, "")}
                      className="accordion-collapse collapse"
                      data-bs-parent="#meetingAccordion"
                    >
                      <div
                        className="accordion-body"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                        onScroll={(e) => handleScroll(e, category?._id)}
                      >
                        {categoryDocs[category?._id]?.documents.length > 0 ? (
                          categoryDocs[category?._id]?.documents?.map(
                            (document, i) => (
                              <div className="meeting-item" key={i}>
                                <div className="d-flex align-items-start">
                                  <i className="bi bi-file-earmark-text meeting-icon"></i>
                                  <div>
                                    <p className="meeting-title mb-1">
                                      {document?.title}
                                    </p>
                                    <p className="meeting-date">
                                      {`${fDate(document?.createdAt)} by ${
                                        document?.createdBy?.firstName || ""
                                      } ${document?.createdBy?.lastName || ""}`}
                                    </p>
                                  </div>
                                </div>
                                <a
                                  href={`${process.env.REACT_APP_API_IMAGE_URL}${document?.file}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-download"
                                  aria-label={`Download document: ${document?.title || "file"}`}
                                >
                                  Download
                                </a>
                              </div>
                            )
                          )
                        ) : (
                          <h3 className="text-danger d-flex justify-content-center">
                            No document
                          </h3>
                        )}

                        {loading &&
                          toggleAccordian?.checked &&
                          toggleAccordian?.position === index + 1 && (
                            <div className="text-center py-2">...Loading</div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="members-section">
          <div className="container">
            <div className="row">
              <div className="accordion" id="meetingAccordion">
                <h2 className="text-danger d-flex justify-content-center">
                  No Categories
                </h2>
              </div>
            </div>
          </div>
        </section>
      )} */
}
